









































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import {
  DimensionsConfigurationDTO,
  ShipmentPackageDTO,
  WineDimensionType
} from "../../../model/data.model";
import { required, minValue } from "vuelidate/lib/validators";
import { isItaly, isUk } from "./../../../services/Helpers";
import store from "../../../vuex/store";
import DecimalNumber from "@/components/shared/DecimalNumber.vue";
import { SelectOptionDef } from "@/model/component.model";
import WineService from "@/services/WineService";

const greaterThanZeroIfSizeMandatory = (value: number) => {
  return !store.getters["customer/config"].packageSizeMandatory || value > 0;
};
const smallerThanMaxPackageWeight = (value: number) => {
  return (
    store.getters["customer/config"].maxPackageWeight === 0 ||
    value <= store.getters["customer/config"].maxPackageWeight
  );
};

@Component({
  components: {
    DecimalNumber
  },
  validations() {
    return {
      shipmentPackage: {
        width: { greaterThanZeroIfSizeMandatory },
        depth: { greaterThanZeroIfSizeMandatory },
        height: { greaterThanZeroIfSizeMandatory },
        customerWeight: {
          required,
          minValue: minValue(0.1),
          smallerThanMaxPackageWeight
        },
        customerVolumetricWeight: {
          smallerThanMaxPackageWeight
        }
      }
    };
  }
})
export default class PackageDefinition extends Vue {
  @Prop() shipmentPackage: ShipmentPackageDTO;
  @Prop() first: boolean;
  @Prop() only: boolean;
  @Prop() allPackagesEqual: boolean;
  @Prop() edition: boolean;
  @Prop() mbePackage: any;
  @Prop() idx: number;
  @Prop({ default: false })
  isWineShipment: boolean;
  @Prop({ default: "" }) wineProduct: string;
  @Prop({ type: Array, default: () => [] }) winePackageTypes;
  @Prop({ type: Boolean, default: false }) hasCourierSelected;
  @Prop({ type: Array, default: () => [] }) specialPackagesCourierWeightList: {
    index: number;
    courierWeight: number;
    customerWeight: number;
  }[];

  packageWidth = "0.0";
  packageHeight = "0.0";
  packageDepth = "0.0";
  packageCustomerWeight = "0.0";
  packageCustomerVolumetricWeight = "0.0";
  packageCustomerTaxedWeight = "0.0";
  packageWinePackType = "STANDARD";

  get packDepth() {
    if (typeof this.packageDepth == "string" && !isUk()) {
      return +this.packageDepth.replace(",", ".");
    } else {
      return this.packageDepth;
    }
  }

  set packDepth(value) {
    this.packageDepth = value.toString();
  }

  get packWidth() {
    if (typeof this.packageWidth == "string" && !isUk()) {
      return +this.packageWidth.replace(",", ".");
    } else {
      return this.packageWidth;
    }
  }

  set packWidth(value) {
    this.packageWidth = value.toString();
  }

  get packHeight() {
    if (typeof this.packageHeight == "string" && !isUk()) {
      return +this.packageHeight.replace(",", ".");
    } else {
      return this.packageHeight;
    }
  }

  set packHeight(value) {
    this.packageHeight = value.toString();
  }

  get packCustomerWeight() {
    if (typeof this.packageCustomerWeight == "string" && !isUk()) {
      return +this.packageCustomerWeight.replace(",", ".");
    } else {
      return this.packageCustomerWeight;
    }
  }

  set packCustomerWeight(value) {
    this.packageCustomerWeight = value.toString();
  }

  @Watch("shipmentPackage.winePackType", { immediate: true })
  onShipmentPackageWinePackTypeChange() {
    this.packageWinePackType = this.shipmentPackage.winePackType
      ? this.shipmentPackage.winePackType
      : "STANDARD";
  }

  @Watch("shipmentPackage.customerWeight")
  adjustPackageCustomerWeight() {
    if (isItaly()) {
      this.packageCustomerWeight = this.shipmentPackage.customerWeight
        .toFixed(1)
        .replace(".", ",");
      this.packageCustomerVolumetricWeight = this.shipmentPackage.customerVolumetricWeight
        .toFixed(1)
        .replace(".", ",");
      this.packageCustomerTaxedWeight = this.shipmentPackage.customerTaxedWeight
        .toFixed(1)
        .replace(".", ",");
    } else {
      this.packageCustomerWeight = this.shipmentPackage.customerWeight.toFixed(
        1
      );
      this.packageCustomerVolumetricWeight = this.shipmentPackage.customerVolumetricWeight.toFixed(
        1
      );
      this.packageCustomerTaxedWeight = this.shipmentPackage.customerTaxedWeight.toFixed(
        1
      );
    }
  }

  async onWinePackTypeChange(val: string) {
    if (!this.wineProduct) return;
    this.shipmentPackage.winePackType = val;
    const bottles = this.shipmentPackage.itemsNumber || 0;
    const magnums = this.shipmentPackage.specialItemsNumber || 0;
    const wineProductType = this.wineProduct.toLowerCase().includes("spirits")
      ? "SPIRITS"
      : "WINE";
    await this.setWineConfigurationDimensions(
      wineProductType,
      val,
      bottles,
      magnums
    );
    this.$emit("recalculateTotalWeight");
  }

  get hasSpiritsUS() {
    return this.wineProduct === "spirits_us";
  }

  async setWineConfigurationDimensions(
    wineProductType: WineDimensionType,
    winePackageType: string,
    bottles: number,
    magnums: number
  ) {
    const configuration = await WineService.prototype.getConfigurationDimension(
      wineProductType,
      winePackageType,
      bottles,
      magnums
    );
    if (!configuration) return;

    this.shipmentPackage.width = configuration.width;
    this.shipmentPackage.height = configuration.height;
    this.shipmentPackage.depth = configuration.length;
    this.shipmentPackage.customerWeight = configuration.customerWeight;

    const fixSpecialPackagesCourierWeightList = (
      data: DimensionsConfigurationDTO
    ) => {
      let foundIndex = -1;
      if (this.specialPackagesCourierWeightList.length) {
        foundIndex = this.specialPackagesCourierWeightList.findIndex(
          (el: any) => el.index === this.idx
        );
      }
      if (foundIndex === -1) {
        this.specialPackagesCourierWeightList.push({
          index: this.idx,
          courierWeight: data.courierWeight,
          customerWeight: data.customerWeight
        });
      } else {
        this.specialPackagesCourierWeightList[foundIndex].courierWeight =
          data.courierWeight;
        this.specialPackagesCourierWeightList[foundIndex].customerWeight =
          data.customerWeight;
      }
    };

    fixSpecialPackagesCourierWeightList(configuration);
    if (!this.isWineShipment && !this.hasSpiritsUS) {
      if (this.hasCourierSelected) {
        this.shipmentPackage.courierWeight = configuration.customerWeight;
      }
    }
  }

  @Watch("shipmentPackage.customerVolumetricWeight")
  changedPackageCustomerVolumetricWeight() {
    this.adjustPackageCustomerWeight();
  }

  @Watch("shipmentPackage.customerTaxedWeight")
  changedPackageCustomerTaxedWeight() {
    this.adjustPackageCustomerWeight();
  }

  @Watch("shipmentPackage.depth")
  changedPackageDepth() {
    if (isItaly()) {
      this.packageDepth = this.shipmentPackage.depth
        .toFixed(1)
        .replace(".", ",");
    } else {
      this.packageDepth = this.shipmentPackage.depth.toFixed(1);
    }
  }

  @Watch("shipmentPackage.height")
  changedPackageHeight() {
    if (isItaly()) {
      this.packageHeight = this.shipmentPackage.height
        .toFixed(1)
        .replace(".", ",");
    } else {
      this.packageHeight = this.shipmentPackage.height.toFixed(1);
    }
  }

  @Watch("shipmentPackage.width")
  changedPackageWidth() {
    if (isItaly()) {
      this.packageWidth = this.shipmentPackage.width
        .toFixed(1)
        .replace(".", ",");
    } else {
      this.packageWidth = this.shipmentPackage.width.toFixed(1);
    }
  }

  created() {
    if (isItaly()) {
      this.packageWidth = this.shipmentPackage.width
        .toFixed(1)
        .replace(".", ",");
      this.packageHeight = this.shipmentPackage.height
        .toFixed(1)
        .replace(".", ",");
      this.packageDepth = this.shipmentPackage.depth
        .toFixed(1)
        .replace(".", ",");
      this.packageCustomerWeight = this.shipmentPackage.customerWeight
        .toFixed(1)
        .replace(".", ",");
      this.packageCustomerVolumetricWeight = this.shipmentPackage.customerVolumetricWeight
        .toFixed(1)
        .replace(".", ",");
      this.packageCustomerTaxedWeight = this.shipmentPackage.customerTaxedWeight
        .toFixed(1)
        .replace(".", ",");
    } else {
      this.packageWidth = this.shipmentPackage.width.toFixed(1);
      this.packageHeight = this.shipmentPackage.height.toFixed(1);
      this.packageDepth = this.shipmentPackage.depth.toFixed(1);
      this.packageCustomerWeight = this.shipmentPackage.customerWeight.toFixed(
        1
      );
      this.packageCustomerVolumetricWeight = this.shipmentPackage.customerVolumetricWeight.toFixed(
        1
      );
      this.packageCustomerTaxedWeight = this.shipmentPackage.customerTaxedWeight.toFixed(
        1
      );
    }
  }

  async triggerDimensionCalculation() {
    if (!this.isWineShipment) return;
    await this.onWinePackTypeChange(this.packageWinePackType);
  }

  async mounted() {
    await this.triggerDimensionCalculation();
  }

  shipmentPackageWidthChanged(e: any) {
    const samePackageVolume =
      parseFloat(this.packageHeight) *
        parseFloat(this.packageWidth) *
        parseFloat(this.packageDepth) ==
      parseFloat(this.packageHeight) * e * parseFloat(this.packageDepth);
    this.packageWidth = e;
    this.shipmentPackage.width = +this.packageWidth;
    if (samePackageVolume) return;
    this.$emit("packageChanged");
  }

  shipmentPackageHeightChanged(e: any) {
    const samePackageVolume =
      parseFloat(this.packageHeight) *
        parseFloat(this.packageWidth) *
        parseFloat(this.packageDepth) ==
      parseFloat(this.packageWidth) * e * parseFloat(this.packageDepth);
    this.packageHeight = e;
    this.shipmentPackage.height = +this.packageHeight;
    if (samePackageVolume) return;
    this.$emit("packageChanged");
  }

  shipmentPackageDepthChanged(e: any) {
    const samePackageVolume =
      parseFloat(this.packageHeight) *
        parseFloat(this.packageWidth) *
        parseFloat(this.packageDepth) ==
      parseFloat(this.packageWidth) * e * parseFloat(this.packageHeight);
    this.packageDepth = e;
    this.shipmentPackage.depth = +this.packageDepth;
    if (samePackageVolume) return;
    this.$emit("packageChanged");
  }

  shipmentPackageCustomerWeightChanged(e: any) {
    this.shipmentPackage.customerWeight = e;
    this.shipmentPackage.courierWeight = e;
    this.$emit("packageChanged");
  }

  @Watch("shipmentPackage.itemsNumber")
  async onShipmentItemsNumberChange() {
    await this.onWinePackTypeChange(this.packageWinePackType);
  }

  itemsNumberChanged(e: any) {
    this.shipmentPackage.itemsNumber = e;
    this.onWinePackTypeChange(this.packageWinePackType);
    this.$emit("packageChanged");
  }

  specialItemsNumberChanged(e: any) {
    this.shipmentPackage.specialItemsNumber = e;
    this.onWinePackTypeChange(this.packageWinePackType);
  }

  isErrorMaxPackageWeight() {
    let maxCustomerWeight = this.shipmentPackage.customerWeight;
    if (
      this.shipmentPackage.customerVolumetricWeight !== undefined &&
      this.shipmentPackage.customerVolumetricWeight > maxCustomerWeight
    )
      maxCustomerWeight = this.shipmentPackage.customerVolumetricWeight;
    if (!smallerThanMaxPackageWeight(maxCustomerWeight)) {
      return true;
    } else {
      return false;
    }
  }

  isErrorNoPackageWeight() {
    if (
      this.shipmentPackage.customerWeight !== undefined &&
      this.shipmentPackage.customerWeight === 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  isErrorPackageSizeMandatory() {
    if (
      !greaterThanZeroIfSizeMandatory(this.shipmentPackage.width) ||
      !greaterThanZeroIfSizeMandatory(this.shipmentPackage.height) ||
      !greaterThanZeroIfSizeMandatory(this.shipmentPackage.depth)
    ) {
      return true;
    } else {
      return false;
    }
  }

  deletePackage(index: any) {
    this.$emit("deletePackage", index);
  }
}
